<div class="wrapper card">
    <div class="card-body">
        <div class="body">
            <h6 class="counter-label m-0 px-1">{{$counterLabel()}}</h6>
            <span class="counter m-0 py-1">{{$counter()}}</span>
        </div>
    </div>
</div>
